import { render } from "./FavoriteComponent.vue?vue&type=template&id=31c0328b"
import script from "./FavoriteComponent.vue?vue&type=script&lang=js"
export * from "./FavoriteComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__